/**
 * Per-site key matching platform-api's `_wp_site_key`: lowercased host, path
 * preserved, scheme/query/fragment dropped, trailing slash trimmed. Two paths
 * on one host (discovery.org vs discovery.org/id) must not collide.
 */
export const wpSiteKey = (baseUrl: string): string | null => {
  const raw = (baseUrl || '').trim();
  if (!raw) return null;
  const withScheme = /^https?:\/\//i.test(raw) ? raw : `https://${raw}`;
  try {
    const u = new URL(withScheme);
    const host = u.hostname.toLowerCase();
    const path = u.pathname.replace(/\/+$/, '');
    return path && path !== '/' ? `${host}${path}` : host;
  } catch {
    return null;
  }
};
